import Meteo from './footer/Meteo'
/**
 * @copyright Swoo Inc
 * @website http://swoo.ca
 * @author Jonathan Simard <jonathan@swoo.ca>
 */
export default class Footer{

	constructor(view, lang){
		console.log('Footer :: init');

		this.view 				= view;
		this.lang				= lang
		this.newsletterForm 	= this.view.querySelector('#newsletter');
		this.newsletterMessage 	= this.view.querySelector('.newsletterMessage');
		this.sending 			= false;

		this.meteo 				= new Meteo();

		this.newsletterForm.addEventListener('submit', this.onSubmitNewsletter.bind(this));
	}

	onSubmitNewsletter(e){
		e.preventDefault();

		let form = e.target;
		let inputValue = form.newsletter_email.value;

		console.log("Footer :: Newsletter :: sending...");
		if(!this.sending){
		    this.sending = true;
		    const xhr = new XMLHttpRequest();
		    xhr.open('POST', 'wp-admin/admin-ajax.php?action=subscribe', true);
		    xhr.onreadystatechange = this.onRSC.bind(this);
		    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		    xhr.send('email='+inputValue+'&lang='+this.lang);
		}else console.log('Footer :: was already sending');
	}


    onCompleteNewsletter(response){
        console.log("Footer :: Newsletter :: respone: ",response);
        if(response){
        	this.newsletterMessage.innerHTML = response.message;
        }else console.error('Footer :: Newsletter :: success == false');
    }

    onRSC(event){
        // Request is not ready yt
        const xhr = event.target;

        if(xhr.readyState != XMLHttpRequest.DONE)
            return;

        try{
            const data = JSON.parse(xhr.responseText);
            this.onCompleteNewsletter(data);
            this.sending = false;

        }catch(e){ console.error('Footer :: Newsletter :: error ::', event); }
    }
        
}